/**
 * This is the starting point of your application.
 * Feature Hub Apps will use this file to bootstrap the app.
 */
import React from 'react';
import { GfaServiceConfigProviderV1 } from '@volkswagen-onehub/gfa-service-config-provider';
import { ContentServiceV1 } from '@oneaudi/content-service';

import { EditorialColumnsProps } from '../types';
import { EditorialColumns } from './components/EditorialColumns';
import { transformCmsDataToProps } from './utils/transformCmsDataToProps';
import { FaceContent, FalconContent, normalizeContent } from './utils/normalize-falcon-data';
import { useLogger } from './Context';

interface FeatureAppProps {
  configProvider?: GfaServiceConfigProviderV1;
  contentService: ContentServiceV1;
  initialContent?: EditorialColumnsProps;
}

const FeatureApp: React.FC<FeatureAppProps> = ({
  contentService,
  initialContent,
}: FeatureAppProps) => {
  const [content, setContent] = React.useState<EditorialColumnsProps | null>(
    transformCmsDataToProps(
      normalizeContent(
        (contentService.getContent() as FalconContent | FaceContent) ?? initialContent,
      ),
    ),
  );
  const logger = useLogger();
  React.useEffect(() => {
    const listener = () => {
      setContent(
        transformCmsDataToProps(
          normalizeContent(
            (contentService.getContent() as FalconContent | FaceContent) ?? initialContent,
          ),
        ),
      );
    };
    contentService.onContentChange(listener);

    return () => {
      contentService.removeOnContentChange(listener);
    };
  }, [contentService, initialContent]);

  if (!content) {
    logger?.info('no content');
    return null;
  }

  return <EditorialColumns {...content} />;
};

export default FeatureApp;
